import { useTranslation } from 'react-i18next'
import { Eye } from 'lucide-react'
import { Button } from '@/ui/components/common/Button'

/**
 * Shown only when the compiled read view includes unpublished leads/facts —
 * i.e. the viewer is privileged for this investigation (admin/streamer/author)
 * and their own session is what's surfacing that extra content, even on the
 * public article URL. Lets them toggle to the same published-only view a
 * public visitor gets, without having to log out.
 */
export function PreviewModeBanner({
  showingPublicOnly,
  onToggle,
}: {
  showingPublicOnly: boolean
  onToggle: () => void
}) {
  const { t } = useTranslation()

  return (
    <div className="print:hidden flex flex-wrap items-center gap-3 justify-between rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-3 mb-6 text-sm">
      <div className="flex items-center gap-2 text-amber-700 dark:text-amber-400">
        <Eye className="h-4 w-4 shrink-0" />
        <span>
          {showingPublicOnly ? t('read_mode.preview_banner_public') : t('read_mode.preview_banner')}
        </span>
      </div>
      <Button variant="outline" size="sm" onClick={onToggle} className="shrink-0">
        {showingPublicOnly
          ? t('read_mode.preview_banner_view_preview')
          : t('read_mode.preview_banner_view_public')}
      </Button>
    </div>
  )
}
